"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInput = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Checkbox_1 = require("@mui/material/Checkbox");
const ListItemText_1 = require("@mui/material/ListItemText");
const renderSelectInputItems = (filter) => {
    return filter.map(({ value, displayText }) => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, Object.assign({ value: value }, { children: displayText }), value)));
};
const renderSelectInputItemsWithCheckbox = (filter, selection) => {
    return filter.map(({ value, displayText }) => ((0, jsx_runtime_1.jsxs)(material_1.MenuItem, Object.assign({ value: value }, { children: [(0, jsx_runtime_1.jsx)(Checkbox_1.default, { checked: selection.indexOf(value) > -1 }, void 0), (0, jsx_runtime_1.jsx)(ListItemText_1.default, { primary: displayText }, void 0)] }), value)));
};
const valueToDisplayText = (options) => (value) => {
    const selectedOption = options.find((option) => option.value === value);
    return selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.displayText;
};
function SelectInput(_a) {
    var { id, label, helperText, options, required = false, FormControlProps, InputLabelProps, renderValue } = _a, selectProps = (0, tslib_1.__rest)(_a, ["id", "label", "helperText", "options", "required", "FormControlProps", "InputLabelProps", "renderValue"]) // value, and onChange as passed in through this like a normal Select component
    ;
    const renderSelectionValueWithEmpty = (selected) => {
        var _a;
        if (!selected || selected.length === 0) {
            return (_a = selectProps.placeholder) !== null && _a !== void 0 ? _a : '';
        }
        if (Array.isArray(selected)) {
            return selected.map(valueToDisplayText(options)).join(', ');
        }
        return valueToDisplayText(options)(selected);
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, Object.assign({}, FormControlProps, { children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, Object.assign({ direction: "row", justifyContent: "space-between", width: "95%", margin: "auto" }, { children: [(0, jsx_runtime_1.jsx)(material_1.FormLabel, Object.assign({ htmlFor: id, id: `${id}-label` }, InputLabelProps, { children: label }), void 0), required && ((0, jsx_runtime_1.jsx)(material_1.Typography, Object.assign({ variant: "caption", color: "text.secondary" }, { children: "Required" }), void 0))] }), void 0), (0, jsx_runtime_1.jsx)(material_1.Select, Object.assign({ displayEmpty: true, renderValue: renderValue ? renderValue : renderSelectionValueWithEmpty, fullWidth: true, sx: {
                    color: selectProps.value ? 'text.primary' : 'text.secondary',
                    width: '95%',
                    margin: 'auto',
                } }, selectProps, { children: selectProps.multiple
                    ? renderSelectInputItemsWithCheckbox(options, selectProps.value)
                    : renderSelectInputItems(options) }), void 0), (0, jsx_runtime_1.jsx)(material_1.FormHelperText, Object.assign({ sx: { width: '95%', margin: 'auto' } }, { children: helperText }), void 0)] }), void 0));
}
exports.SelectInput = SelectInput;
//# sourceMappingURL=select-input.js.map